export const generalErrorMsg = () => ({
    header: 'Wooops!',
    body: 'Something went wrong, try again or contact us'
});

export const contactErrorMsg = () => ({
    header: 'Wooops!',
    body: 'Missing a valid email address and/or message content'
});

export const invalidEmailErrorMsg = () => ({
    header: 'Wooops!',
    body: 'This email is not valid'
});



// WEBPACK FOOTER //
// ./src/Models/errors.js